export function DashboardJobsCtrl (
  $scope,
  $state,
  $translate,
  messages,
  workshopAPI
) {

  $scope.tableSettings = {
    columns: [
      {
        field : 'post_date',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe: 'globalDate',
      },
      {
        field : 'invoice_number',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.INV_NO')
        }
      },
      {
        field : 'display_name',
        header: {
          text: $translate.instant('CUSTOMER_SPACE.CUSTOMER')
        }
      },
      {
        field : 'vehicle',
        header: {
          text: $translate.instant('VEHICLE_SPACE.VEHICLE')
        }
      },
      {
        classes: 'text-right',
        field  : 'total',
        header : {
          classes: 'text-right',
          text   : $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency',
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_RECENTLY_COMPLETED_JOBS')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10 ],
      queryCount: () => workshopAPI.get('/dashboard/recently_completed_count').then(data => data.count)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.combine = function() {
    angular.forEach($scope.jobs, (row) => {
      row.vehicle = ( row.vehicle_id
          ? `${row.plate_number}  ${row.make}  ${row.model}`
          : ''
      );
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $state.go('app.invoice', {
      customer_id: event.row.job_customer_id || event.row.customer_id,
      vehicle_id : event.row.job_vehicle_id || event.row.vehicle_id,
      id         : event.row.job_id || event.row.invoice_id
    });
  };

  $scope.getJobs = ( params ) => {
    return workshopAPI.get('/dashboard/recently_completed', [
      params.pageSize,
      params.offset,
    ])
    .then(jobs => {
      $scope.jobs = jobs;

      $scope.combine();

      return jobs;
    });
  };

  $scope.refresh = function () {
    $state.reload();

    messages.show($translate.instant('JS_SPACE.MESSAGES.REFRESHED'), 'success');
  };

  $scope.combine();
}